import salesApi from '@/api/sales';

const state = {
    listAllServices: null,
    listDeals: null,
    sale: null,
    saleInfo: null,
    monitorInfo: null,
    isLoadingSale: false,
    isLoadingMonitor: false,
    validationErrors: null,
    listOrganizations: null,
    rentals: null,
    rentalsTypes: null,
    salePrint:null,
    saleHistory:null,
    salePromo:null,
    contractList:null,
    isLoading:null,
    nomenclatureList:null
}

export const mutationTypes = {
    getSalesAllListStart: '[salesAllList] Get sales all list start',
    getSalesAllListSuccess: '[salesAllList] Get sales all list success',
    getSalesAllListFailure: '[salesAllList] Get sales all list failure',

    getSalesListStart: '[salesList] Get sales list start',
    getSalesListSuccess: '[salesList] Get sales list success',
    getSalesListFailure: '[salesList] Get sales list failure',

    getSaleInfoStart: '[saleInfo] Get sale info start',
    getSaleInfoSuccess: '[saleInfo] Get sale info success',
    getSaleInfoFailure: '[saleInfo] Get sale info failure',

    createSaleStart: '[sale] Create sale start',
    createSaleSuccess: '[sale] Create sale success',
    createSaleFailure: '[sale] Create sale failure',

    editSaleStart: '[sale] Edit sale start',
    editSaleSuccess: '[sale] Edit sale success',
    editSaleFailure: '[sale] Edit sale failure',

    getSalesNodealStart: '[sale] Get sales nodeal start',
    getSalesNodealSuccess: '[sale] Get sales nodeal success',
    getSalesNodealFailure: '[sale] Get sales nodeal failure',

    getSalesOrganizationsStart: '[sale] Get sales organizations start',
    getSalesOrganizationsSuccess: '[sale] Get sales organizations success',
    getSalesOrganizationsFailure: '[sale] Get sales organizations failure',

    createSalePartStart: '[sale] Create sale Part start',
    createSalePartSuccess: '[sale] Create sale Part success',
    createSalePartFailure: '[sale] Create sale Part failure',

    buyDeleteStart: '[sale] Buy Delete start',
    buyDeleteSuccess: '[sale] Buy Delete success',
    buyDeleteFailure: '[sale] Buy Delete failure',

    getRentalsTypesStart: '[rentalstypes] Get Rentals Types start',
    getRentalsTypesSuccess: '[rentalstypes] Get Rentals Types success',
    getRentalsTypesFailure: '[rentalstypes] Get Rentals Types failure',

    createRentalStart: '[rentals] Create Rentals start',
    createRentalSuccess: '[rentals] Create Rentals success',
    createRentalFailure: '[rentals] Create Rentals failure',

    printSaleStart: '[salePrint] Print sale start',
    printSaleSuccess: '[salePrint] Print sale success',
    printSaleFailure: '[salePrint] Print sale failure',

    saleHistoryStart: '[saleHistory] Sale History start',
    saleHistorySuccess: '[saleHistory] Sale History success',
    saleHistoryFailure: '[saleHistory] Sale History failure',

    salePromoStart: '[salePromo] Sale Promo start',
    salePromoSuccess: '[salePromo] Sale Promo success',
    salePromoFailure: '[salePromo] Sale Promo failure',

    getContractListStart: '[getContractList] Get Contract List start',
    getContractListSuccess: '[getContractList] Get Contract List success',
    getContractListFailure: '[getContractList] Get Contract List failure',

    getNomenclatureFullStart: '[getNomenclatureFull] Get Nomenclature Full start',
    getNomenclatureFullSuccess: '[getNomenclatureFull] Get Nomenclature Full success',
    getNomenclatureFullFailure: '[getNomenclatureFull] Get Nomenclature Full failure',
    
}

export const salesActionTypes = {
    getSalesAllList: '[salesAllList] Get all sales list',
    getSalesList: '[customSalesList] Get client sales list',
    getSaleInfo: '[saleInfo] Get sale info',
    createSale: '[sale] Create sale',
    editSale: '[sale] Edit sale',
    getSalesNodeal: '[sale] Get sales nodeal',
    getSalesOrganizations: '[sale] Get sales organizations',
    createSalePart: '[sale] Create sale Part',
    buyDelete: '[sale] Buy Delete',
    getRentalsTypes: '[rentalstypes] Get rentals types',
    createRental: '[rentals] Create rental',
    printSale: '[salePrint] Print sale',
    saleHistory: '[saleHistory] Sale history',
    salePromo: '[salePromo] Sale promo',
    getContractList: '[getContractList] Get Contract List',
    getNomenclatureFull: '[getNomenclatureFull] Get Nomenclature Full'
}

const mutations = {
    [mutationTypes.getSalesAllListStart](state) {
        state.isLoadingSale = true
        state.listAllServices = null
        state.saleInfo = null
    },
    [mutationTypes.getSalesAllListSuccess](state, payload) {
        state.isLoadingSale = false
        state.listAllServices = payload
        state.validationErrors = null
    },
    [mutationTypes.getSalesAllListFailure](state,payload) {
        state.isLoadingSale = false
        state.validationErrors = payload
    },

    [mutationTypes.getSalesListStart](state) {
        state.isLoadingSale = true
        state.listAllServices = null
    },
    [mutationTypes.getSalesListSuccess](state, payload) {
        state.isLoadingSale = false
        state.listAllServices = payload
        state.validationErrors = null
    },
    [mutationTypes.getSalesListFailure](state,payload) {
        state.isLoadingSale = false
        state.validationErrors = payload
    },

    [mutationTypes.getSaleInfoStart](state) {
        state.isLoadingSale = true
        state.saleInfo = null
    },
    [mutationTypes.getSaleInfoSuccess](state, payload) {
        state.isLoadingSale = false
        state.saleInfo = payload
        state.validationErrors = null
    },
    [mutationTypes.getSaleInfoFailure](state, payload) {
        state.isLoadingSale = false
        state.validationErrors = payload
    },

    [mutationTypes.createSaleStart](state) {
        state.isLoadingSale = true
        state.validationErrors = null
    },
    [mutationTypes.createSaleSuccess](state, payload) {
        state.isLoadingSale = false
        state.sale = payload
        state.validationErrors = null
    },
    [mutationTypes.createSaleFailure](state,payload) {
        state.isLoadingSale = false
        state.validationErrors = payload
    },

    [mutationTypes.editSaleStart](state) {
        state.isLoadingSale = true
        state.validationErrors = null
    },
    [mutationTypes.editSaleSuccess](state, payload) {
        state.isLoadingSale = false
        state.sale = payload
        state.validationErrors = null
    },
    [mutationTypes.editSaleFailure](state,payload) {
        state.isLoadingSale = false
        state.validationErrors = payload
    },

    [mutationTypes.getSalesNodealStart](state) {
        state.isLoadingSale = true
        state.listDeals = null
    },
    [mutationTypes.getSalesNodealSuccess](state, payload) {
        state.isLoadingSale = false
        state.listDeals = payload
        state.validationErrors = null
    },
    [mutationTypes.getSalesNodealFailure](state,payload) {
        state.isLoadingSale = false
        state.validationErrors = payload
    },

    [mutationTypes.getSalesOrganizationsStart](state) {
        state.isLoadingSale = true
        state.listOrganizations = null
    },
    [mutationTypes.getSalesOrganizationsSuccess](state, payload) {
        state.isLoadingSale = false
        state.listOrganizations = payload
        state.validationErrors = null
    },
    [mutationTypes.getSalesOrganizationsFailure](state,payload) {
        state.isLoadingSale = false
        state.validationErrors = payload
    },

    [mutationTypes.createSalePartStart](state) {
        state.isLoadingSale = true
        state.validationErrors = null
    },
    [mutationTypes.createSalePartSuccess](state, payload) {
        state.isLoadingSale = false
        state.sale = payload
        state.validationErrors = null
    },
    [mutationTypes.createSalePartFailure](state,payload) {
        state.isLoadingSale = false
        state.validationErrors = payload
    },

    [mutationTypes.buyDeleteStart](state) {
        state.isLoadingSale = true
        state.validationErrors = null
    },
    [mutationTypes.buyDeleteSuccess](state, payload) {
        state.isLoadingSale = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.buyDeleteFailure](state,payload) {
        state.isLoadingSale = false
        state.validationErrors = payload
    },


    [mutationTypes.getRentalsTypesStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getRentalsTypesSuccess](state, payload) {
        state.isLoading = false
        state.rentalsTypes = payload
        state.validationErrors = null
    },
    [mutationTypes.getRentalsTypesFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },
    [mutationTypes.createRentalStart](state) {
        state.isLoadingSale = true
        state.validationErrors = null
    },
    [mutationTypes.createRentalSuccess](state, payload) {
        state.isLoadingSale = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.createRentalFailure](state,payload) {
        state.isLoadingSale = false
        state.validationErrors = payload
    },
    [mutationTypes.printSaleStart](state) {
        state.isLoadingSale = true
        state.validationErrors = null
    },
    [mutationTypes.printSaleSuccess](state, payload) {
        state.isLoadingSale = false
        state.salePrint = payload
        state.validationErrors = null
    },
    [mutationTypes.printSaleFailure](state,payload) {
        state.isLoadingSale = false
        state.validationErrors = payload
    },

    [mutationTypes.saleHistoryStart](state) {
        state.isLoadingSale = true
        state.validationErrors = null
    },
    [mutationTypes.saleHistorySuccess](state, payload) {
        state.isLoadingSale = false
        state.saleHistory = payload
        state.validationErrors = null
    },
    [mutationTypes.saleHistoryFailure](state,payload) {
        state.isLoadingSale = false
        state.validationErrors = payload
    },

    [mutationTypes.salePromoStart](state) {
        state.isLoadingSale = true
        state.validationErrors = null
    },
    [mutationTypes.salePromoSuccess](state, payload) {
        state.isLoadingSale = false
        state.salePromo = payload
        state.validationErrors = null
    },
    [mutationTypes.salePromoFailure](state,payload) {
        state.isLoadingSale = false
        state.validationErrors = payload
    },

    [mutationTypes.getContractListStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getContractListSuccess](state, payload) {
        state.isLoading = false
        state.contractList = payload
        state.validationErrors = null
    },
    [mutationTypes.getContractListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getNomenclatureFullStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getNomenclatureFullSuccess](state, payload) {
        state.isLoading = false
        state.nomenclatureList = payload
        state.validationErrors = null
    },
    [mutationTypes.getNomenclatureFullFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },
    
}

const actions = {
    [salesActionTypes.getSalesAllList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getSalesAllListStart)
            salesApi
                .getSalesAllList(data)
                .then(response => {
                    context.commit(mutationTypes.getSalesAllListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getSalesAllListFailure,response)
                })
        })
    },
    [salesActionTypes.getSalesList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getSalesListStart)
            salesApi
                .getSalesList(data)
                .then(response => {
                    context.commit(mutationTypes.getSalesListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getSalesListFailure,response)
                })
        })
    },
    [salesActionTypes.getSaleInfo](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getSaleInfoStart)
            salesApi
                .getSaleInfo(data)
                .then(response => {
                    context.commit(mutationTypes.getSaleInfoSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getSaleInfoFailure, response)
                })
        })
    },
    [salesActionTypes.createSale](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.createSaleStart)
            salesApi
                .createSale(data)
                .then(response => {
                    context.commit(mutationTypes.createSaleSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.createSaleFailure,response)
                })
        })
    },
    [salesActionTypes.editSale](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.editSaleStart)
            salesApi
                .editSale(data)
                .then(response => {
                    context.commit(mutationTypes.editSaleSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.editSaleFailure,response)
                })
        })
    },
    [salesActionTypes.getSalesNodeal](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getSalesNodealStart)
            salesApi
                .getSalesNodeal(data)
                .then(response => {
                    context.commit(mutationTypes.getSalesNodealSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getSalesNodealFailure,response)
                })
        })
    },
    [salesActionTypes.getSalesOrganizations](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getSalesOrganizationsStart)
            salesApi
                .getSalesOrganizations(data)
                .then(response => {
                    context.commit(mutationTypes.getSalesOrganizationsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getSalesOrganizationsFailure,response)
                })
        })
    },
    [salesActionTypes.createSalePart](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.createSalePartStart)
            salesApi
                .createSalePart(data)
                .then(response => {
                    context.commit(mutationTypes.createSalePartSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.createSalePartFailure,response)
                })
        })
    },
    [salesActionTypes.buyDelete](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.buyDeleteStart)
            salesApi
                .buyDelete(data)
                .then(response => {
                    context.commit(mutationTypes.buyDeleteSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.buyDeleteFailure,response)
                })
        })
    },

    [salesActionTypes.getRentalsTypes](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getRentalsTypesStart)
            salesApi
                .getRentalsTypes(data)
                .then(response => {
                    context.commit(mutationTypes.getRentalsTypesSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getRentalsTypesFailure,response)
                })
        })
    },
    [salesActionTypes.createRental](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.createRentalStart)
            salesApi
                .createRental(data)
                .then(response => {
                    context.commit(mutationTypes.createRentalSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.createRentalFailure,response)
                })
        })
    },
    [salesActionTypes.printSale](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.printSaleStart)
            salesApi
                .printSale(data)
                .then(response => {
                    context.commit(mutationTypes.printSaleSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.printSaleFailure,response)
                })
        })
    },
    [salesActionTypes.saleHistory](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.saleHistoryStart)
            salesApi
                .saleHistory(data)
                .then(response => {
                    context.commit(mutationTypes.saleHistorySuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.saleHistoryFailure,response)
                })
        })
    },
    [salesActionTypes.salePromo](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.salePromoStart)
            salesApi
                .salePromo(data)
                .then(response => {
                    context.commit(mutationTypes.salePromoSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.salePromoFailure,response)
                })
        })
    },
    [salesActionTypes.getContractList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getContractListStart)
            salesApi
                .getContractList(data)
                .then(response => {
                    context.commit(mutationTypes.getContractListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getContractListFailure,response)
                })
        })
    },
    [salesActionTypes.getNomenclatureFull](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getNomenclatureFullStart)
            salesApi
                .getNomenclatureFull(data)
                .then(response => {
                    context.commit(mutationTypes.getNomenclatureFullSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getNomenclatureFullFailure,response)
                })
        })
    },
    
}

export default {
    state,
    actions,
    mutations
}